// extracted by mini-css-extract-plugin
module.exports = {"aboutMe__socialButtons":"AboutMe_aboutMe__socialButtons_3_b4u","aboutMe__block":"AboutMe_aboutMe__block_3SWS4","aboutMe__strike":"AboutMe_aboutMe__strike_2c_RD"};